import { createApp } from 'vue';
import VConsole from 'vconsole';
import vant from 'vant';
import router from './router';
import App from './App.vue';
import 'vant/lib/index.css';

if (import.meta.env.MODE !== 'production') {
  new VConsole();
}

const app = createApp(App);

app.use(router);

app.use(vant);

app.mount('#app');
